// src/components/sidebar/DynamicIcon.jsx
import {
  LayoutDashboard,
  ClipboardCheck,
  TrendingUp,
  BrainCircuit,
  ShieldCheck,
  UserSearch,
  UserCheck,
  BarChart3,
  Eye,
  Settings,
} from "lucide-react";

const iconMap = {
  LayoutDashboard,
  ClipboardCheck,
  TrendingUp,
  BrainCircuit,
  ShieldCheck,
  UserSearch,
  UserCheck,
  BarChart3,
  Eye,
  Settings,
};

const DynamicIcon = ({ name, size = 18, color = "currentColor" }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent size={size} color={color} />;
};

export default DynamicIcon;